"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

var _uigDeviceUtil = _interopRequireDefault(require("@sfly/uig-device-util"));

require("./style.css");

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !_construct.default) return false;
    if (_construct.default.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call((0, _construct.default)(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = (0, _construct.default)(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

var Component =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Component, _React$PureComponent);

  var _super = _createSuper2(Component);

  function Component() {
    var _this;

    (0, _classCallCheck2.default)(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSpinnerImage", function () {
      var isDesktop = _uigDeviceUtil.default.desktop();

      return isDesktop ? "https://www.".concat((0, _uigCurrentEnvironmentUtil.getBaseHostname)(), "/css/spinners/").concat(_this.props.spinnerColor, "/2x/spinner-xl.png") : "https://www.".concat((0, _uigCurrentEnvironmentUtil.getBaseHostname)(), "/css/spinners/").concat(_this.props.spinnerColor, "/1x/spinner-xl.png");
    });
    return _this;
  }

  (0, _createClass2.default)(Component, [{
    key: "render",
    value: function render() {
      if (!this.props.isSpinnerVisible) {
        return null;
      }

      var spinnerClass = "spinner ".concat(this.props.labelPosition);
      var spinnerImageClass = "spinner-".concat(this.props.size);
      var spinnerImage = this.getSpinnerImage();
      return _react.default.createElement("div", {
        className: spinnerClass
      }, _react.default.createElement("div", {
        className: spinnerImageClass
      }, _react.default.createElement("img", {
        alt: "spinner",
        src: spinnerImage
      })), this.props.isLabelVisible && _react.default.createElement("div", {
        className: "label-text"
      }, this.props.labelText));
    }
  }]);
  return Component;
}(_react.default.PureComponent);

exports.default = Component;
Component.propTypes = {
  isSpinnerVisible: _propTypes.default.bool,
  spinnerColor: _propTypes.default.oneOf(['orange', 'white']),
  isLabelVisible: _propTypes.default.bool,
  labelText: _propTypes.default.string,
  labelPosition: _propTypes.default.oneOf(['top', 'right', 'left', 'bottom']),
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
};
Component.defaultProps = {
  isSpinnerVisible: true,
  spinnerColor: 'orange',
  isLabelVisible: false,
  labelText: 'Loading ...',
  labelPosition: 'right',
  size: 'md'
};

//# sourceMappingURL=index.js.map